<script>
export default {
  name: 'TemplateCard',
  props: {
    selected: Boolean,
    template: Object
  }
};
</script>

<template>
  <div :class="{'template-card': true, selected}" @click="$emit('click', $event)">
    <div class="template-card-icon">
      <i class="el-icon-fa-code" />
    </div>
    <div class="template-card-name">
      <router-link
        :to="{
          name: 'EditTemplate',
          params: { siteId: template.siteId, templateId: template.id }
        }"
      >
        {{ template.name }}
      </router-link>
    </div>
    <div class="template-card-description">
      {{ template.description }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.template-card {
  display: block;
  position: relative;
  background: $--color-white;
  border-top: solid 1px darken($--color-gray-10, 2.5%);
  box-shadow: $--box-shadow-small;
  padding: 1.5rem 1.25rem 1.5rem 4rem;
  user-select: none;

  &:first-child {
    border-top: none;
  }

  &.selected {
    background-color: $--color-primary-light-9;
    border-top-color: darken($--color-primary-light-9, 5%);
    color: $--color-primary;

    .template-card-icon,
    .template-card-name,
    .template-card-description {
      color: inherit;
    }

    .template-card-icon {
      color: darken($--color-primary-light-9, 10%);
    }
  }

  &.selected:last-child {
    border-bottom-color: darken($--color-primary-light-9, 5%);
  }

  &.selected + .template-card {
    border-top-color: darken($--color-primary-light-9, 5%);
  }
}

.template-card-icon {
  position: absolute;
  top: 1rem;
  left: 1rem;
  font-size: 1.8rem;
  color: $--color-gray-20;
}

.template-card-description {
  font-size: $--font-size-small;
  color: $--color-gray-40;
  padding-right: 1.5rem;
  margin: 0.25rem 0 0 0;
}
</style>
